import { Component, OnInit , ViewChild} from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupSegmentComponent } from '../../shared/components/popupAdmin/popup-segment.component';
import {AlyleUIModule,LyResizingCroppingImageModule} from '../../../alyle-ui';
import { AdminImageCroperComponent } from '../../shared/components/popupAdmin/popup-imagecropper.component';

@Component({
    selector: 'app-dashboard',
    templateUrl: './Updatesegments.component.html',
    // styleUrls: ['./dashboard.component.scss']
inputs: ['value'],
     providers: [ SharedService,PopupSegmentComponent,AdminImageCroperComponent],

})
export class UpdateSegmentsComponent implements OnInit {


data = [];
imageDta: any;
  imageData: any=[];
  croppedWidth: number;
  croppedHeight: number;
    data1: any;
    segmentUpdCrtForm:FormGroup;
    segmentImage="";
    loaderFlag : boolean;
    id :number;
    page = 1;
    name = "";
    description ="";
    imgUrl = "";
    updateImageFlag = false;
    objLoaderStatus: boolean = false;
    successUplaodImg = '';
    imgId :number = 0 ;
    blob:any;
imageFlagUplaod = false;
    constructor(private localstorage: LocalStorage,
     private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private shareService: SharedService ,private route: ActivatedRoute,
  private router: Router,private PopupSegment: PopupSegmentComponent, 
    private dialogService:DialogService) {

    
    }

    ngOnInit() {
        var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 
this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
this.localstorage.setStorage("country",'');

this.segmentUpdCrtForm = this.formBuilder.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      imgUrl : ['']
    });

this.route.params.subscribe(params => {
    this.id = Number.parseInt(params['id']);
    this.page = Number.parseInt(params['page']);
});

 var token = this.localstorage.getStorage("token");
               this.loaderService.displayLoader(true);

  this.shareService.CallDatawithToken("master/segments?currentSize=1000", null, token).subscribe((result) => {
    if(result.data){
    this.data = result.data;
}

      console.log(this.data.length);
var i=0;
         for(i=0;i<this.data.length;i++){
             
             if(this.data[i].id == this.id){
this.name = this.data[i].name;
this.description = this.data[i].description;
this.imgUrl = this.data[i].imgUrl;

             }
         }
              this.loaderService.displayLoader(false);

         });
    }

  showImageBox() {
        let disposable = this.dialogService.addDialog(AdminImageCroperComponent, {
            title: 'Draft Campaign',
            message: 'Campaign Saved Successfully.'
         })
            .subscribe((result) => {
                //We get dialog result
                  if (result.isConfirmed && result.imgId !== undefined) {
                    this.imgId = result.imgId;
                  this.updateImageFlag = true;
                                      this.imageFlagUplaod = false;

                }
                else if(result.isConfirmed == false && result.imgId !== undefined){
                    this.imgId = result.imgId;
                  this.imageFlagUplaod = true;
                  this.updateImageFlag = false;
                    var pView=document.getElementById("segmentImage");
                   
                  this.imgUrl =  pView.getAttribute("src");
                }
                else{
                    this.imgId = 0;
                      this.imageFlagUplaod = false;
                                        this.updateImageFlag = true;

                }
            });
        //We can close dialog calling disposable.unsubscribe();
        //If dialog was not closed manually close it by timeout
    }

   b64toBlobNew(b64Data,contentType){
      var byteCharacters = atob(b64Data);
      var byteNumbers = new Array(byteCharacters.length);
for (var i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
}

var byteArray = new Uint8Array(byteNumbers);
var blob = new Blob([byteArray], {type: contentType});
return blob;
  }


  uploadImage() {
    this.loaderFlag=true;
    let fileList: FileList = this.imageData;
     console.log(fileList);
     let file: File = fileList[0];
     let formData:FormData = new FormData();
      formData.append('profilePic', this.blob);
    var token = this.localstorage.getStorage("token");
   // var compaignId = this.localstorage.getStorage("compaignId");
                 this.loaderService.displayLoader(true);

    // var bannerImage={"banner":this.data1.image};
    this.shareService.uploadImage("admin/uploadSegmentImage", formData, token).subscribe((result) => {
    if (result.data) {
        console.log(result.data);
        if(result.data.id !== null){
            this.imgId = result.data.id;
           // this.segmentUpdCrtForm.valid= true;
            this.successUplaodImg="Image successfully uploaded.";
          } else {
            this.successUplaodImg="";
          }
          setTimeout(() => {
              this.loaderFlag=false;
              this.successUplaodImg="";
          }, 3000);
          
      } else {
          this.loaderFlag=false;
      }
      this.loaderService.displayLoader(false);
    });
  }
  
urltoFile(url, filename, mimeType){
    return (fetch(url)
        .then(function(res){return res.arrayBuffer();})
        .then(function(buf){return new File([buf], filename, {type:mimeType});})
    );
}

  checkimageURL(url) {
      if(url) {
          return(url.match(/\.(jpeg|jpg|gif|png)$/) != null);
      }
      
    }

fileChangeListener($event) {
    
    this.imageDta = $event.target.files;
    console.log(this.imageDta);
    var image: any = new Image();
    var file: File = $event.target.files[0];
    var myReader: FileReader = new FileReader();
    var that = this;
    document.getElementsByTagName("canvas")[0].style.display = "block";
    myReader.onloadend =  (loadEvent:any)=> {
       // image.src = loadEvent.target.result;
        var imageDta=loadEvent.target.result;
        let type=imageDta.split(';')[0].split(':')[1];
        console.log(type);
        console.log(type.split("/")[1]);
        var extention=type.split("/")[1];
        //let type = this.imageDta.split(';')[0].split(':')[1];
        //let extension=type.splif("/")[1];
        this.urltoFile(imageDta,'croped.'+extention,type).then((result) => {
            this.imageDta[0]=result;
            
    });
        
      //  that.cropper.setImage(image);
    };
   var t= myReader.readAsDataURL(file);
   console.log(t);
  }

updateData(){
     var token = this.localstorage.getStorage("token");
     var data : any ={};
   
     data.imgId = this.imgId;
     if(data.imgId == undefined){
         data.imgId = 0;
     }
     data.name = this.name;
     data.description = this.description;
                 this.loaderService.displayLoader(true);

       this.shareService.callApiWithToken("admin/updateSegment?id="+this.id, data, token).subscribe((result) => {
    console.log(result.data);
   if(result.data && (result.data.id !== '' || result.data.id !== undefined)){
   
    this.name = result.data.name;
    this.description = result.data.description;
    this.imgId = result.data.imgId;
    this.imgUrl = result.data.imgUrl;
    this.updateImageFlag = false;
    this.showUpdate();
   }
 
                 this.loaderService.displayLoader(false);

         });
}

  showUpdate() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Segment Information', 
                message:"Segment Updated Successfully",
              data: [],
            showcancel : false})
                .subscribe((isConfirmed)=>{
                     this.router.navigate(['admin/segments']);

                });
        }

}



// WEBPACK FOOTER //
// ./src/app/admin/layout/updateCreateSegments/Updatesegments.component.ts